import React, { useState, useEffect } from 'react'
import { IonModal, IonHeader } from '@ionic/react'
import i18n from 'i18next'
import { format } from '@dt/fe-utils'
import { memberMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import './activityInfo.scss'

interface IProps{
  activeInfo: any;
  prizeNum?: number;
  goPrize: () => void;
  goRecord: () => void;
  reject?: () => void;
  resolve?: () => void;
}
export const ActivityInfo: React.FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { reject, activeInfo, prizeNum, goPrize, goRecord } = props
  const [prizeSettings, setPrizeSettings] = useState<string[]>([])
  useEffect(() => {
    const _prizeSettings: string[] = []
    if (activeInfo.extra?.prizeSettings) {
      Object.keys(activeInfo.extra.prizeSettings).forEach((key) => {
        if (activeInfo.extra.prizeSettings[key] && key !== 'upperLimit') _prizeSettings.push(key)
      })
    }
    setPrizeSettings(_prizeSettings)
  }, [activeInfo])
  return (
    <IonModal
      cssClass='coupon-detail-modal lucky-draw-activity'
      isOpen
      showBackdrop
      backdropDismiss
      onDidDismiss={reject}
    >
      <div className='activity-info-content'>
        <IonHeader className='modal-header'>
          <span className='title'>{i18n.t('mkt.market.marketDetail')}</span>
          <i className='iconfont icon-close' onClick={reject}></i>
        </IonHeader>
        <div className='modal-body'>
          {
            activeInfo.extra && activeInfo.extra.copywriting &&
              <div className='detail-des'>
                <div className='title'>{i18n.t('mkt.activity.introduce')}</div>
                <div className='des'>{activeInfo.extra.copywriting}</div>
              </div>
          }
          <div className='detail-des prize' onClick={goPrize}>
            <div className='title'>{i18n.t('mkt.pointCard.activeRewards')}</div>
            <div><i className='iconfont icon-chevron-right' /></div>
          </div>
          {
            prizeNum !== 0 &&
              <div className='detail-des prize' onClick={goRecord}>
                <div className='title'>{i18n.t('mkt.activity.myPrize')}</div>
                <div><i className='iconfont icon-chevron-right' /></div>
              </div>
          }
          {
            activeInfo.extra &&
              <div className='detail-des'>
                <div className='title'>{i18n.t('mkt.activity.rules')}</div>
                <div className='info-area'>
                  {
                    activeInfo.extra?.prizeSettings?.upperLimit &&
                      <div className='info-item'>
                        <div className='line-block'>
                          <div className='left'>
                            {i18n.t('mkt.activity.drawUpLimit')}
                          </div>
                          <div className='right'>
                            {i18n.t('common.times', { num: activeInfo.extra.prizeSettings.upperLimit.upperLimitNum })}
                          </div>
                        </div>
                      </div>
                  }
                  <div className='info-item'>
                    <div className='line-block'>
                      <div className='left'>
                        {i18n.t('mkt.activity.times')}
                      </div>
                      <div className='right'>
                        {format.toDateTime(activeInfo.startTime)} ~ {format.toDateTime(activeInfo.endTime)}
                      </div>
                    </div>
                  </div>
                  {
                    prizeSettings.map((item) => {
                      if (item === 'staticGive') {
                        const { staticGive = {} } = activeInfo.extra?.prizeSettings
                        const cardNames: string[] = []
                        if (staticGive?.cardIds) {
                          staticGive?.cardIds.forEach((item: any) => {
                            if (memberMobx.cardListMap[item]) cardNames.push(memberMobx.cardListMap[item]?.card.cardName)
                          })
                        }
                        return (
                          <div className='info-item' key='staticGive'>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.staticGive')}
                              </div>
                              <div className='right'>
                                {staticGive.isAllMember ? i18n.t('mkt.activity.anyone') : cardNames.join('、')}
                              </div>
                            </div>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.giveNum')}
                              </div>
                              <div className='right'>
                                {i18n.t('mkt.activity.howManyNum', { num: activeInfo.extra.prizeSettings.staticGive.prizeTimes })}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (item === 'cycleGive') {
                        const { cycleGive = {} } = activeInfo.extra?.prizeSettings
                        const cardNames: string[] = []
                        if (cycleGive?.cardIds) {
                          cycleGive?.cardIds.forEach((item: any) => {
                            if (memberMobx.cardListMap[item]) cardNames.push(memberMobx.cardListMap[item]?.card.cardName)
                          })
                        }
                        return (
                          <div className='info-item' key='cycleGive'>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.cycleGive')}
                              </div>
                              <div className='right'>
                                {cycleGive.isAllMember ? i18n.t('mkt.activity.anyone') : cardNames.join('、')}
                              </div>
                            </div>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.giveNum')}
                              </div>
                              <div className='right'>
                                {activeInfo.extra.prizeSettings.cycleGive.cycleType === 'dayCycle' && i18n.t('mkt.activity.cycleGiveType1', { num: activeInfo.extra.prizeSettings.cycleGive.prizeTimes })}
                                {activeInfo.extra.prizeSettings.cycleGive.cycleType === 'weekCycle' && i18n.t('mkt.activity.cycleGiveType2', { num: activeInfo.extra.prizeSettings.cycleGive.prizeTimes })}
                                {activeInfo.extra.prizeSettings.cycleGive.cycleType === 'monthCycle' && i18n.t('mkt.activity.cycleGiveType3', { num: activeInfo.extra.prizeSettings.cycleGive.prizeTimes })}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (item === 'giftCardRechargeGive') {
                        const { giftCardRechargeGive = {} } = activeInfo.extra?.prizeSettings
                        const cardNames: string[] = []
                        if (giftCardRechargeGive?.cardIds) {
                          giftCardRechargeGive?.cardIds.forEach((item: any) => {
                            if (memberMobx.giftCardListMap[item]) cardNames.push(memberMobx.giftCardListMap[item]?.giftcard.cardName)
                          })
                        }
                        return (
                          <div className='info-item' key='giftCardRechargeGive'>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.giftCardRechargeGive')}
                              </div>
                              <div className='right'>
                                {giftCardRechargeGive.isAllMember ? i18n.t('mkt.activity.allGiftCard') : cardNames.join('、')}
                              </div>
                            </div>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.giveNum')}
                              </div>
                              <div className='right'>
                                {i18n.t('mkt.activity.rechargeEnough', {
                                  money: activeInfo.extra.prizeSettings.giftCardRechargeGive.money,
                                  num: activeInfo.extra.prizeSettings.giftCardRechargeGive.prizeTimes
                                })}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (item === 'memberCardRechargeGive') {
                        const { memberCardRechargeGive = {} } = activeInfo.extra?.prizeSettings
                        const cardNames: string[] = []
                        if (memberCardRechargeGive?.cardIds) {
                          memberCardRechargeGive?.cardIds.forEach((item: any) => {
                            if (memberMobx.cardListMap[item]) cardNames.push(memberMobx.cardListMap[item]?.card.cardName)
                          })
                        }
                        return (
                          <div className='info-item' key='memberCardRechargeGive'>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.memberCardRechargeGive')}
                              </div>
                              <div className='right'>
                                {memberCardRechargeGive.isAllMember ? i18n.t('mkt.activity.allMemberCard') : cardNames.join('、')}
                              </div>
                            </div>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.giveNum')}
                              </div>
                              <div className='right'>
                                {i18n.t('mkt.activity.rechargeEnough', {
                                  money: activeInfo.extra.prizeSettings.memberCardRechargeGive.money,
                                  num: activeInfo.extra.prizeSettings.memberCardRechargeGive.prizeTimes
                                })}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (item === 'inviteGive') {
                        return (
                          <div className='info-item' key='inviteGive'>
                            <div className='line-block'>
                              <div className='left'>
                                {i18n.t('mkt.activity.inviteGive')}
                              </div>
                              <div className='right'>
                                {activeInfo.extra.prizeSettings.inviteGive.inviteType === 'signMember' && i18n.t('mkt.activity.inviteGiveType1', {
                                  p: activeInfo.extra.prizeSettings.inviteGive.inviteNum,
                                  num: activeInfo.extra.prizeSettings.inviteGive.prizeTimes
                                })}
                                {activeInfo.extra.prizeSettings.inviteGive.inviteType === 'memberConsume' && i18n.t('mkt.activity.inviteGiveType2', {
                                  p: activeInfo.extra.prizeSettings.inviteGive.inviteNum,
                                  num: activeInfo.extra.prizeSettings.inviteGive.prizeTimes
                                })}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      return <div key={item} />
                    })
                  }
                </div>
              </div>
          }
        </div>
      </div>
    </IonModal>
  )
}
